import React, { Component } from "react";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as enrolGIRONowSelector from "../../../common/selectors/enrolGIRONow";
import * as enrolGIRONowAction from "../../../common/actions/enrolGIRONow";
import CustomBoardRenewal from "../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import Color from "../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../components/CustomTextInput";
import CustomButton from "../../components/CustomButton";
import _ from "lodash";
import AuthManager from "../../../utils/AuthManager";
import Image from "../../../assets";
import { Helmet } from "react-helmet";
import CustomBoardGiro from "../../components/CustomBoardGiro";
import CustomEnrolGiroNowV2 from "../../components/CustomEnrolGiroNowV2";
import LoadingOverlay from "../../components/LoadingOverlay";
import CustomPaper from "../../components/CustomPaper";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import * as authSelector from "../../../common/selectors/auth";
import * as authAction from "../../../common/actions/auth";

const screenW = window.screen.width + "px";
const screenH = "450" + "px";

class EnrolGiroNow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      policyNo: "",
      giroReference: "",
      isOnClickNext: false,
      isProcessingGiroReference: false,
      showPolicyInput: true,
      error: false,
      errorMsg: "",
      localMaintainMsg: [],
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  formatDate(date) {
    return (
      [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-") +
      "T" +
      [
        this.padTo2Digits(date.getHours()),
        this.padTo2Digits(date.getMinutes()),
        this.padTo2Digits(date.getSeconds()),
      ].join(":")
    );
  }

  extractGiroReferenceFromURL = () => {
    const extractRawParam = (queryString, paramName) => {
      if (!queryString) {
        return null;
      }

      const normalizedQuery = queryString.charAt(0) === "?" ? queryString.slice(1) : queryString;
      const queryParts = normalizedQuery.split("&");

      for (const part of queryParts) {
        if (!part) {
          continue;
        }

        const separatorIndex = part.indexOf("=");
        const key = separatorIndex >= 0 ? part.substring(0, separatorIndex) : part;

        if (key === paramName) {
          return separatorIndex >= 0 ? part.substring(separatorIndex + 1) : "";
        }
      }

      return null;
    };

    // For hash-based routing, check query string in hash first (raw, not decoded)
    const hash = window.location.hash || "";
    const hashQueryIndex = hash.indexOf("?");

    if (hashQueryIndex >= 0) {
      const hashQueryString = hash.substring(hashQueryIndex + 1);
      const giroReferenceFromHash = extractRawParam(hashQueryString, "GiroReference");

      if (giroReferenceFromHash !== null) {
        return giroReferenceFromHash;
      }
    }

    // Fallback to regular URL query string (raw, not decoded)
    return extractRawParam(window.location.search, "GiroReference");
  };

  processGiroReference = (giroReference) => {
    if (giroReference) {
      this.setState({
        giroReference: giroReference,
        showPolicyInput: false,
        isProcessingGiroReference: true,
        error: false,
        errorMsg: ""
      });
      
      const { getDDAPolicy } = this.props;
      getDDAPolicy("", giroReference);
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getMaintenanceMsg();
    localStorage.setItem("EnrolGiroFooter", "true");
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    AuthManager.removeToken();
    
    // Check for GIRO reference in URL and process automatically
    const giroReference = this.extractGiroReferenceFromURL();
    this.processGiroReference(giroReference);
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.getDDAPolicyData !== this.props.getDDAPolicyData) {
      const ddaPolicyData = enrolGIRONowSelector.getDDAPolicyDataData(
        this.props.getDDAPolicyData
      );
      const status = enrolGIRONowSelector.getDDAPolicyDataStatus(ddaPolicyData);
      const msg = enrolGIRONowSelector.getDDAPolicyDataMsg(ddaPolicyData);

      //console.log("ddaPolicyData",ddaPolicyData)
      if (status === true) {
        const { history } = this.props;
        history.push("/EnrolGiroInfo");
      } else {
        this.setState({ errorMsg: msg });
        this.setState({ error: true });
      }
    }

    if (prevProps.getMaintenanceMsgData !== this.props.getMaintenanceMsgData) {
      console.log("ssss", this.props.getMaintenanceMsgData);
      
      this.props.getMaintenanceMsgData.length > 0 && this.props.getMaintenanceMsgData.map((item, index) => {
        // if (
        //   new Date(this.formatDate(new Date())) >=
        //     new Date(item.Effective_Date) &&
        //   new Date(this.formatDate(new Date())) < new Date(item.End_Date)
        // ) {
        // }
      });
      this.setState({ localMaintainMsg: this.props.getMaintenanceMsgData?.MaintenanceMessage });
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onChangePolicyNo = (event) => {
    this.setState({ policyNo: event.target.value });
  };

  onClickNext = () => {
    const { history } = this.props;
    const { policyNo, giroReference } = this.state;
    this.setState({ isOnClickNext: true });
    
    // If we have a GIRO reference from URL, use that instead of policy number
    if (giroReference) {
      const { getDDAPolicy } = this.props;
      this.setState({
        isProcessingGiroReference: true,
        error: false,
        errorMsg: ""
      });
      getDDAPolicy("", giroReference);
      return;
    }
    
    // Otherwise, process policy number as before
    if (this.state.policyNo === "") {
      this.setState({
        error: true,
        errorMsg: "You must specify a value for this required field.",
      });
    } else {
      const { getDDAPolicy } = this.props;
      getDDAPolicy(this.state.policyNo, "");
    }
  };

  onClickHere = () => {
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  validateTextInput = () => {
    const { policyNo } = this.state;
    return _.isEmpty(policyNo);
  };

  onClickBack = () => {
    window.history.back();
  };

  renderChildren = () => {
    const { classes } = this.props;
    const { policyNo, isOnClickNext, errorMsg, error, showPolicyInput, giroReference } = this.state;
    return (
      <CustomPaper
        container
        direction={"column"}
        spacing={2}
        design={classes.paper}
        style={{marginTop:this.state.localMaintainMsg.length > 0 ? -1:""}}
      >
        <Grid
          item
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <img
            src={Image.eGiroLogo}
            style={{ width: 110, height: 58, objectFit: "contain" }}
          />
        </Grid>
        <Grid item>
          <CustomText
            design={classes.renewNowTextStyle}
            style={{ color: "#424143" }}
          >
            Enrol GIRO payment for your policy
          </CustomText>
        </Grid>
        <Grid item>
          <CustomText
            design={classes.renewNowTextStyleV2}
            style={{ color: "#424143" }}
          >
            Enter the policy number to retrieve details
          </CustomText>
        </Grid>
        
        <Grid container style={{ marginBottom: 15 }}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <CustomTextInput
              title={"Policy Number"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={this.state.policyNo}
              onChange={this.onChangePolicyNo}
              errorMessage={errorMsg}
              error={error}
              disabled={!!giroReference}
            />
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>

        <Grid container>
          <Grid item xs={4}></Grid>
          <Grid item xs={4}>
            <CustomButton
              title={"Proceed"}
              design={classes.nextButtonStyle}
              onClick={this.onClickNext}
              disabled={!!giroReference}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>

        

        {/* <Grid item>
          <CustomText design={classes.bottomTextStyle} component="div">
            For customers with an Online Account, you may log in{" "}
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyle}
              onClick={this.onClickHere}
            >
              here
            </CustomText>{" "}
            to use your eWallet credits.
          </CustomText>
        </Grid> */}
      </CustomPaper>
    );
  };

  renderChildrenV2 = () => {
    const { classes } = this.props;
    const { policyNo, isOnClickNext, errorMsg, error, showPolicyInput, giroReference } = this.state;
    return (
      <>
        {" "}
        {this.state.localMaintainMsg.length > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 30,
            }}
          >
            <div style={{ width: window.innerWidth * 0.4, color: "#899499" }}>
              {this.state.localMaintainMsg.length > 0
                ? this.state.localMaintainMsg.map((item, index) => {
                    return new Date(this.formatDate(new Date())) >=
                      new Date(item.Effective_Date) &&
                      new Date(this.formatDate(new Date())) <
                        new Date(item.Expiry_Date) ? (
                      <span style={{color:"red"}}>{item.Message}</span>
                    ) : (
                      false
                    );
                  })
                : false}
            </div>
          </div>
        )}
        <CustomPaper
          container
          direction={"column"}
          spacing={2}
          design={classes.paper}
        >
          <Grid
            item
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <img
              src={Image.eGiroLogo}
              style={{ width: 110, height: 58, objectFit: "contain" }}
            />
          </Grid>
          <Grid item>
            <CustomText
              design={classes.renewNowTextStyle}
              style={{ color: "#424143" }}
            >
              Enrol GIRO payment for your policy
            </CustomText>
          </Grid>
          <Grid item>
            <CustomText
              design={classes.renewNowTextStyleV2}
              style={{ color: "#424143" }}
            >
              Enter the policy number to retrieve details
            </CustomText>
          </Grid>
          
          <Grid container style={{ marginBottom: 15 }}>
            <Grid item xs={1}></Grid>
            <Grid item xs={10}>
              <CustomTextInput
                title={"Policy Number"}
                textstyle={classes.labelTextInputTextStyle}
                design={classes.textInputContainer}
                fullWidth={true}
                value={this.state.policyNo}
                onChange={this.onChangePolicyNo}
                errorMessage={errorMsg}
                error={error}
                disabled={!!giroReference}
              />
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>

          <Grid container>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}>
              <CustomButton
                title={"Proceed"}
                design={classes.nextButtonStyle}
                onClick={this.onClickNext}
                disabled={!!giroReference}
              />
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>

          {error && (
            <Grid item xs={12}>
              <CustomText style={{ color: "red", textAlign: "center" }}>
                {errorMsg}
              </CustomText>
            </Grid>
          )}

          {/* <Grid item>
        <CustomText design={classes.bottomTextStyle} component="div">
          For customers with an Online Account, you may log in{" "}
          <CustomText
            display={"inline"}
            design={classes.highLightedTextStyle}
            onClick={this.onClickHere}
          >
            here
          </CustomText>{" "}
          to use your eWallet credits.
        </CustomText>
      </Grid> */}
        </CustomPaper>
      </>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        <Helmet>
          <title>Enrol GIRO</title>
        </Helmet>

        {/* <div className={classes.headerStyle} style={{display:"inline-block"}}>
          <div  >
            <img src={Image.renewalHeader} style={{height:"42px"}} />
          </div>
          <div style={{textAlign:"center"}}>
            <CustomText design={classes.headerTextStyle}>
              Policy Renewal
            </CustomText>
          </div>
        </div> */}

        {window.innerWidth < 601 ? (
          <CustomEnrolGiroNowV2
            children={this.renderChildrenV2()}
            height={height}
            width={width}
          />
        ) : (
          false
        )}
        {window.innerWidth > 600 ? (
          <AppBar
            position="sticky"
            className={classes.appBar}
            style={{ background: "#333333" }}
          >
            <Toolbar
              className={classes.toolbarStyle}
              style={{
                justifyContent: "space-between",
                //alignItems: "center",
                display: "flex-start",
                flexDirection: "row",
                marginLeft: "5em",
              }}
            >
              <img
                src={Image.nonDirectClientEtiqaLogo}
                style={{ width: 112, height: 60 }}
              />
            </Toolbar>
          </AppBar>
        ) : (
          false
        )}
        {window.innerWidth > 600 && this.state.localMaintainMsg.length > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 30,
            }}
          >
            <div style={{ width: window.innerWidth * 0.4, color: "#899499" }}>
              {this.state.localMaintainMsg.length > 0
                ? this.state.localMaintainMsg.map((item, index) => {
                    return new Date(this.formatDate(new Date())) >=
                      new Date(item.Effective_Date) &&
                      new Date(this.formatDate(new Date())) <
                        new Date(item.Expiry_Date) ? (
                      <span style={{color:"red"}}>{item.Message}</span>
                    ) : (
                      false
                    );
                  })
                : false}
            </div>
          </div>
        )}
        {window.innerWidth > 600 ? this.renderChildren() : false}

        <Grid container style={{marginTop:"1rem"}}>
          <Grid item xs={4}></Grid>
          <Grid item xs={4} style={{marginLeft:"-3%",}}>
           <CustomText style={{color:"#1c4498"}}>Note: This service is unavailable between 12am to 10am.  </CustomText>
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>

        {this.props.getDDAPolicyLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    maxHeight: "108vh",
    minHeight: "108vh",
    //  backgroundImage: window.innerWidth < 601 ? false : `url(${Image.enrolGiroBg})`,
    //  backgroundSize:window.innerWidth < 601 ? false : `${screenW} ${screenH}`,
    //  backgroundPosition: window.innerWidth < 601 ? false : "bottom center",
    //  backgroundRepeat: window.innerWidth < 601 ? false :"no-repeat",
    backgroundImage: `url(${Image.enrolGiroBg})`,
    backgroundSize: `${screenW} ${screenH}`,
    backgroundPosition: "bottom center",
    backgroundRepeat: "no-repeat",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "grey",
      //opacity:0.5
      //outline: '1px solid slategrey'
    },
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("400"),
    fontSize: "16px",
    color: "#424143",
    fontFamily: "Muli",
  },
  textInputContainer: {
    height: 45,
    marginTop: 7,
  },
  nextButtonStyle: {
    //width: 150,
    marginTop: 10,
    marginBottom: 10,
    height: 40,
    fontFamily: "Muli",
    fontSize: "18px",
  },
  nextTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    fontWeight: "bold",
    fontFamily: "Muli",
    fontSize: 22,
    textAlign: "center",
    marginBottom: 10,
    marginTop: 10,
  },
  renewNowTextStyleV2: {
    ...getFontWeight("400"),
    fontSize: 17,
    textAlign: "center",
    fontFamily: "Muli",
    marginBottom: 45,
  },
  errorTextStyle: {
    color: "red",
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  headerStyle: {
    backgroundColor: "#5b5b5b",
  },
  headerTextStyle: {
    color: "white",
    textAlign: "center",
    fontSize: "28px",
  },
  paper: {
    // overflow: "auto",
    //backgroundColor: "#f4f4f4",
    fontFamily: "Muli",
    marginTop: window.innerWidth < 601  ? false : "6%",
    marginLeft: window.innerWidth < 601 ? false : "30%",
    marginRight: window.innerWidth < 601 ? false : "30%",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "grey",
      //opacity:0.5
      //outline: '1px solid slategrey'
    },
  },
});

function mapStateToProps(state) {
  return {
    getDDAPolicyData: selector.getDDAPolicyData(state),
    getDDAPolicyLoading: selector.getDDAPolicyLoading(state),
    getDDAPolicyStatus: selector.getDDAPolicyStatus(state),
    getMaintenanceMsgLoading: selector.getMaintenanceMsgLoading(state),
    getMaintenanceMsgData: selector.getMaintenanceMsgData(state),
    getMaintenanceMsgStatus: selector.getMaintenanceMsgStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDDAPolicy: (policyNumber,GiroReference) =>
      dispatch(enrolGIRONowAction.getDDAPolicy(policyNumber,GiroReference)),
    getMaintenanceMsg: () => dispatch(authAction.getMaintenanceMsg()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(EnrolGiroNow)));
